import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import custom tools */
import timestamp from '../../../assecs/plugin/timestamp'; 

/* import element from component folder */
import Select from '../../../components/select';
import Editor from "../../../views/combination/editor";

/* import fetch function */
import { EditEventPoint } from "../../../services/events";

const CreatePointEvent = () => {
    const { data } = useSelector(state => state.model);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState(data);
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        if (name === 'pointType')
            delete error.codeId;
        else
            delete error[name];

        if (value.length) {
            if (name === 'pointType')
                _source.codeId = value;
            else
                _source[name] = value;
        }
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {
            EditEventPoint({ epId: data.epId, source: source }).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['eventName', 'codeId', 'value', 'reward', 'startDate', 'endDate'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Edit Data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='eventName' placeholder='Please enter the event name.' is-required={`${error.eventName}`} defaultValue={ source.eventName } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='pointType' select_all={ false } shadow={ false } required={ error.codeId } _default={ source.codeId } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Value</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='value' placeholder='Please enter the eligibility threshold.' defaultValue={ source.value } is-required={`${error.value}`} disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Reward</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='reward' placeholder='Please enter the reward points.' defaultValue={ source.reward } is-required={`${error.reward}`} disabled />
                    </div>
                    <div className="form-item">
                        <div className='label'>Event Date</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='pointType' placeholder='Please enter the reward points.' defaultValue={ `${timestamp.getDates(source.startDate)} ~ ${timestamp.getDates(source.endDate)}` } is-required={`${error.reward}`} disabled />
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreatePointEvent;